export default {"src":"/_next/static/media/hamburger.4b3ddd09.svg","height":16,"width":18};